// extracted by mini-css-extract-plugin
export var copy = "stat-module--copy--ec002";
export var dark = "stat-module--dark--1add4";
export var headline = "stat-module--headline--a58c6";
export var light = "stat-module--light--49451";
export var stat = "stat-module--stat--69970";